var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOffLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.902 16.08A9.124 9.124 0 0 1 10 17.5 9.169 9.169 0 0 1 .985 10a9.151 9.151 0 0 1 2.782-5.055L1.161 2.34 2.34 1.16l16.499 16.5-1.178 1.178-2.759-2.758ZM4.946 6.126A7.471 7.471 0 0 0 2.686 10a7.504 7.504 0 0 0 11 4.865l-1.69-1.69a3.75 3.75 0 0 1-5.171-5.171l-1.879-1.88Zm5.816 5.815L8.06 9.239a2.083 2.083 0 0 0 2.701 2.701Zm6.577 1.887-1.192-1.192c.546-.78.95-1.67 1.168-2.635A7.504 7.504 0 0 0 7.96 4.448L6.645 3.133A9.143 9.143 0 0 1 10 2.5c4.494 0 8.232 3.233 9.016 7.5a9.122 9.122 0 0 1-1.677 3.827Zm-7.57-7.57a3.75 3.75 0 0 1 3.974 3.974L9.77 6.257Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffLine);
export default __webpack_public_path__ + "static/media/eye-off-line.c0ab8eb1356c85f013b3bb603b7e54b5.svg";
export { ForwardRef as ReactComponent };